export const isValidEmail = (email: string): boolean => {
  const MAX_EMAIL_LENGTH = 254;
  const isInvalidInput = !email || email.length === 0 || email.length > MAX_EMAIL_LENGTH;

  if (isInvalidInput) return false;

  const emailRegex = /[^\s@]+@[^\s@]+\.[^\s@]+/;

  return emailRegex.test(email);
};

export const isOnlyNumbers = (value: string): boolean => {
  if (!value || value.length === 0) return false;

  // Check if the string contains only digits (0-9)
  const numberRegex = /^\d+$/;

  return numberRegex.test(value);
};

export const isValidNumberOfCharacters = (value: string, min: number, max: number): boolean => {
  if (!value) return false;

  const { length } = value;

  return length >= min && length <= max;
};
